// This function takes a React Document and parses the JSON
const processBiography = (doc: any) => {
    let biographyData = null;
    biographyData = JSON.parse(doc);

    return biographyData;
}

export default processBiography;